import dynamic from 'next/dynamic';
import { Layout, StatisticsWrapper } from '../index.js';
const Customers = dynamic(() => import('../Customers.js'), { ssr: false });
const Features = dynamic(() => import('../Features.js'), { ssr: false });
const WatchVideoDemo = dynamic(() => import('../Form/watch_video_demo.js'), { ssr: false });
const Demo = dynamic(() => import('../Demo.js'), { ssr: false });
const DownloadBrochureForm = dynamic(() => import('../Form/download_brochure.js'));
const SignupForm = dynamic(() => import('../Form/signup.js'), { ssr: false });
const MailForm = dynamic(() => import('../Form/mail.js'), { ssr: false });
const Faq = dynamic(() => import('../Faq.js'), {
	loading: () => (
		<section className="faq">
			<h2 className="faq__heading">Frequently Asked Questions:</h2>
		</section>
	),
});

import Link from 'next/link';
import { GEO_LOCATION_CONFIG } from '../../data/geo_location_config.js';

export default function Home({ geoConfig = GEO_LOCATION_CONFIG.DEFAULT }) {
	// Homepage props
	const {
		headingList,
		heroTagline,
		heroMessage,
		heroCtaText,
		heroMailHeader,
		heroWatchVideoDemoHeader,
		heroClientFeedbacksHeader,
		heroEmailText,
		faultNumberMessage,
	} = geoConfig.homepage;
	const clientFeedbacksPagePath = geoConfig.clientFeedbacks.pagePath;

	// Layout props
	const layoutProps = {
		pageName: geoConfig.homepage.pageName,
		homePagePath: geoConfig.homepage.pagePath,
		pricingPagePath: geoConfig.pricing.pagePath,
		clientFeedbacksPagePath: clientFeedbacksPagePath,
	};

	return (
		<Layout {...layoutProps}>
			<section className="hero">
				<div className="container">
					<div className="hero__wrapper">
						<div className="hero__content">
							<div className="hero__content-heading-wrapper">
								<h1 className="hero__content-heading">{headingList[headingList.length - 1]}</h1>

								{headingList.map((heading, index) => (
									<h1 className={`hero__content-heading ${index === 0 ? 'reduce-size' : ''}`} key={index}>
										{heading}
									</h1>
								))}
							</div>
							<h2 className="hero__content-tagline">{heroTagline}</h2>
							<h3 className="hero__content-message">{heroMessage}</h3>

							<div className="hero__content-cta">
								<div className="cta-wrapper">
									<SignupForm btnText={heroCtaText} btnClass="btn btn--cta" type={{ name: 'trial' }} />
								</div>

								<div className="brochure">
									<DownloadBrochureForm classNameBtn="btn btn--cta" />
								</div>
							</div>

							<div className="hero__content-mail">
								<div className="mail mail--w60">
									<span className="mail__header">{heroMailHeader}</span>
									<MailForm />
								</div>

								<div className="mail">
									<div className="mail__header">{heroWatchVideoDemoHeader}</div>
									<WatchVideoDemo classNameBtn="btn btn--cta-video-demo" />
								</div>
							</div>

							<div className="hero__content-email">
								<span className="mail__header">
									<Link href={clientFeedbacksPagePath} className="email-link">
										{heroClientFeedbacksHeader}
									</Link>
								</span>

								<div className="mail__header">
									Or Email&nbsp;
									<a href={`mailto:${heroEmailText}`} className="email-link">
										{heroEmailText}
									</a>
								</div>
							</div>
						</div>

						<StatisticsWrapper faultNumberMessage={faultNumberMessage} />
					</div>
				</div>
			</section>

			<Demo />

			<Customers />

			<div className="bg-img__wrapper">
				<div className="bg-img bg-img--lb"></div>
				<div className="bg-img bg-img--r"></div>
				<div className="bg-img bg-img--rb"></div>

				<Features />
			</div>

			<div>
				<Faq />
			</div>
		</Layout>
	);
}
